var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-card',{scopedSlots:_vm._u([{key:"content",fn:function(){return [(!_vm.loading)?_c('div',[_c('the-calendar')],1):_vm._e(),(_vm.loading)?_c('card-loading-transparent'):_vm._e()]},proxy:true}])},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.$t('agenda'))+" ")]),_c('template',{slot:"actions"},[_c('p')])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }